import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

const api = axios.create({
  baseURL: BASE + "/api",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token from localStorage if present
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("hin_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) {
    // ignore
  }
  return config;
});

export default api;
